{
  "blockType": "hero-minimal",
  "root": {
    "children": [
      {
        "children": [
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "duration": 400,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  12,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              }
            },
            "className": "@ds:uiBlock.heroBanner.semiboldEmphasis @ds:uiBlock.heroBanner.accentForeground @ds:uiBlock.heroBanner.supportingText @ds:uiBlock.heroBanner.eyebrowTracking @ds:uiBlock.heroBanner.labelCase",
            "id": "minimal-eyebrow",
            "text": "The future is here",
            "type": "text"
          },
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "duration": 600,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  28,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              }
            },
            "className": "@ds:uiBlock.heroBanner.maximumEmphasis @ds:uiBlock.heroBanner.displayHeadingText @ds:uiBlock.heroBanner.primaryForeground @ds:uiBlock.heroBanner.tightTracking @ds:uiBlock.heroBanner.balancedText @ds:uiBlock.heroBanner.adaptiveDisplayHeading @ds:uiBlock.heroBanner.prominentDisplayHeading",
            "id": "minimal-title",
            "level": 1,
            "text": "The simplest way to build great software",
            "type": "heading"
          },
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "delay": 200,
                "duration": 400,
                "opacity": [
                  0,
                  1
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              }
            },
            "className": "h-px w-16 @ds:uiBlock.heroBanner.separatorSurface",
            "id": "minimal-separator",
            "type": "container"
          },
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "delay": 150,
                "duration": 500,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  16,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              }
            },
            "className": "max-w-xl @ds:uiBlock.heroBanner.comfortableLeading @ds:uiBlock.heroBanner.leadText @ds:uiBlock.heroBanner.supportingForeground @ds:uiBlock.heroBanner.balancedText @ds:uiBlock.heroBanner.adaptiveLeadText",
            "id": "minimal-subtitle",
            "text": "Stop wrestling with complex tools. Focus on your product and let us handle the rest.",
            "type": "text"
          },
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "delay": 250,
                "duration": 500,
                "opacity": [
                  0,
                  1
                ],
                "translateY": [
                  16,
                  0
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              }
            },
            "className": "h-14 @ds:uiBlock.heroBanner.actionTopSeparation @ds:uiBlock.heroBanner.primaryAction @ds:uiBlock.heroBanner.strongActionElevation",
            "icon": "arrow-right",
            "iconPosition": "right",
            "id": "minimal-cta",
            "interaction": {
              "cursor": "pointer",
              "hover": {
                "scale": 1.04
              },
              "press": {
                "scale": 0.97
              },
              "transition": {
                "curve": "ease-out",
                "duration": 200,
                "properties": [
                  "transform"
                ]
              }
            },
            "size": "lg",
            "text": "Start Building Today",
            "type": "button",
            "variant": "default"
          },
          {
            "animation": {
              "enter": {
                "curve": "ease-out",
                "delay": 350,
                "duration": 400,
                "opacity": [
                  0,
                  1
                ]
              },
              "scroll": {
                "once": true,
                "threshold": 0.1,
                "trigger": "inView"
              }
            },
            "className": "@ds:uiBlock.heroBanner.subtleForeground @ds:uiBlock.heroBanner.supportingText",
            "id": "minimal-note",
            "text": "Free to start. No credit card. Upgrade when you are ready.",
            "type": "text"
          }
        ],
        "className": "mx-auto flex max-w-3xl flex-col items-center @ds:uiBlock.heroBanner.centeredText @ds:uiBlock.heroBanner.pageCluster @ds:uiBlock.heroBanner.sectionSpacing",
        "id": "hero-minimal-inner",
        "type": "container"
      }
    ],
    "className": "flex flex-col items-center justify-center @ds:uiBlock.heroBanner.viewportMinimumHeight @ds:uiBlock.heroBanner.pageInlineInset @ds:uiBlock.heroBanner.pageBlockInset @ds:uiBlock.heroBanner.adaptivePageBlockInset @ds:uiBlock.heroBanner.root",
    "id": "hero-minimal-root",
    "type": "section"
  },
  "schemaVersion": "4.0"
}
